import styled from 'styled-components';

export const VerifyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 16px;
  padding: 16px;
`;
export const TitleContainer = styled.div`
  margin-left: 10px;
  margin-top: 10px;
`;

export const WrapperQuote = styled.div<{ $divider?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  margin-top: 16px;
  padding-bottom: 16px;
  border-bottom: ${({ $divider = true }) =>
    $divider ? '1px solid #D9CEAF' : 'none'};
`;

export const InfoQuote = styled.div<{ $divider?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  margin-top: 16px;
  padding-bottom: 16px;
  border-bottom: ${({ $divider = true }) =>
    $divider ? '1px solid #D9CEAF' : 'none'};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 100%;
`;

export const IconText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
  gap: 5px;
`;

export const Icon = styled.img`
  cursor: pointer;
  width: 16px;
  height: 16px;
`;

export const MontosContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  margin-top: 16px;
  width: 100%;
`;
export const SubtitlesContainer = styled.div`
  display: flex;
  padding: 12px 8px;
`;
export const RowAmount = styled.div<{ $divider?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 12px 8px;
  border-bottom: ${({ $divider = true }) =>
    $divider ? '1px solid #D9CEAF' : 'none'};

  .label {
    color: #7b6a3a;
    font-size: 14px;
    line-height: 1.4;
    font-weight: 400;
  }

  .value {
    color: #0c0c0c;
    font-size: 16px;
    line-height: 1.4;
    font-weight: 500;
    white-space: nowrap;
  }
`;

export const RowClientInfo = styled.div<{ $divider?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 12px 8px;
  border-bottom: ${({ $divider = true }) =>
    $divider ? '1px solid #D9CEAF' : 'none'};

  * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: #d9ceaf33;
  width: 100%;
`;
export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  background: #f9faf9;
`;
